import { Link as RouterLink } from 'react-router-dom';

import PropTypes from 'prop-types';

import { Box, Button, Grid, Link, Typography } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import GenericFormContainer from '../Forms/GenericFormContainer';

import CarsonLogo from '../../res/svg/CarsonLogoS.svg';
import AppleLogin from './AppleLogin';
import AuthDivider from './AuthDivider';
import FacebookLoginComponent from './FacebookLogin';
import SignInWithGoogle from './SignInWithGoogle';
import { StyledSocialMediaButtonContainer } from './styledComponents';

const LoginComponent = (props) => {
  const { t } = useTransl();
  const {
    onSubmit,
    onResetRequested,
    userForgotPassword,
    signInWithFacebook,
    signInWithGoogle,
    signInWithApple,
    toggleForgotPasswordState,
    form,
    formData,
    isNotAllowedToLogin,
  } = props;

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      wrap="nowrap"
      sx={{
        margin: 'auto',
        height: '100%',
        width: '34rem',
        padding: '7rem 0 0 0',
      }}
    >
      <Box sx={{ mb: '3rem', width: '50%' }}>
        <img
          style={{ width: '100%' }}
          src={CarsonLogo}
          alt={t('altLabel.carsonLogo')}
        />
      </Box>
      <GenericFormContainer
        form={form}
        formData={formData}
        onSubmit={userForgotPassword ? onResetRequested : onSubmit}
        canBeUpdated={false}
        title={t('actions.login')}
        submitText={
          userForgotPassword ? t('actions.resetPassword') : t('actions.login')
        }
        customSubmitStyle={{ borderRadius: '20px' }}
        backButton={false}
        onLoad={() => {}}
        isCentered
        isFullWidthForm
        isFullWidthSubmit
      />
      <Box width="100%">
        <Button
          type="button"
          variant="outlined"
          disableElevation
          sx={{
            width: '100%',
            margin: '-1rem 0 0 0',
            borderRadius: '20px',
          }}
          onClick={(e) => toggleForgotPasswordState(e)}
        >
          {userForgotPassword ? t('actions.back') : t('actions.forgotPassword')}
        </Button>
        <AuthDivider />
        <StyledSocialMediaButtonContainer>
          <FacebookLoginComponent
            loginWithFacebook={signInWithFacebook}
            facebookButtonLabel={t('auth.signInWithFacebook')}
          />
        </StyledSocialMediaButtonContainer>
        <StyledSocialMediaButtonContainer>
          <AppleLogin
            signInWithApple={signInWithApple}
            appleButtonLabel={t('auth.signInWithApple')}
          />
        </StyledSocialMediaButtonContainer>
        <StyledSocialMediaButtonContainer>
          <SignInWithGoogle onSignInWithGoogle={signInWithGoogle} isLogin />
        </StyledSocialMediaButtonContainer>
        <Grid container justifyContent="center" mt="2rem">
          <Typography align="center" fontSize="1.4rem">
            {t('auth.loginByInviteOnly')}
          </Typography>
          {!!isNotAllowedToLogin && (
            <Typography align="center" fontSize="1.4rem">
              <Link component={RouterLink} to="/support">
                {t('auth.downloadResidentApp')}
              </Link>
            </Typography>
          )}
        </Grid>
      </Box>
    </Grid>
  );
};

LoginComponent.propTypes = {
  form: PropTypes.string.isRequired,
  formData: PropTypes.instanceOf(Array).isRequired,
  userForgotPassword: PropTypes.bool.isRequired,
  signInWithFacebook: PropTypes.func.isRequired,
  signInWithGoogle: PropTypes.func.isRequired,
  signInWithApple: PropTypes.func.isRequired,
  toggleForgotPasswordState: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onResetRequested: PropTypes.func.isRequired,
  isNotAllowedToLogin: PropTypes.bool,
};

export default LoginComponent;
